import {store} from "@irati/store"

import {Branding} from "@irati/types"
import AuthServiceBase from "../streams/auth/base"
import GlobalStream from "../streams/global"
import Auth from "../types/Auth"
import AuthActions from "./actions/AuthActions"

export type OnNext = (branding: Branding) => void

interface AuthServiceWithBranding {
  subscribe: AuthServiceBase<Auth | any>["subscribe"]
}

class SyncToRedux {
  private authedListener: ZenObservable.Subscription | null = null

  private globalData: any | null = null

  constructor() {
    // Due to circular refs, we need to delay this to next JS tick using setTimeout
    setTimeout(() => {
      if (!this.authedListener) {
        this.authedListener = this.listenToAuth(GlobalStream, (auth) => {
          this.globalData = {
            branding: auth.branding
          }
          this.next()
        })
      }
    })
  }

  private next() {
    if (this.globalData) {
      store.dispatch(AuthActions.SyncFromV4(this.globalData))
    }
  }

  private listenToAuth(service: AuthServiceWithBranding, update: (data: any | null) => void) {
    return service.subscribe(
      (auth) => {
        update(auth)
      },
      undefined,
      () => {
        update(null)
        this.authedListener = this.listenToAuth(service, update)
      }
    )
  }
}

export default new SyncToRedux()
